import React from "react";
import style from "./footer.module.css";
import Contact from "../Contact/Contact";

export default function Footer() {
  return (
    <div className={style.container}>
      <div className={style.contact}>
        <Contact />
      </div>
      <div>Desarrollado por © Pedro Muñoz</div>
    </div>
  );
}
